import { render, staticRenderFns } from "./TenantStatus.vue?vue&type=template&id=1452a64c&scoped=true"
import script from "./TenantStatus.vue?vue&type=script&lang=js"
export * from "./TenantStatus.vue?vue&type=script&lang=js"
import style0 from "./TenantStatus.vue?vue&type=style&index=0&id=1452a64c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1452a64c",
  null
  
)

export default component.exports